import { useRef, useState } from 'react';
import { selectEntries, sourceCategories } from '../domain/selectors';
import type { ScenarioEntry } from '../domain/types';
import { ScenarioEntryInspector } from './ScenarioEntryInspector';
import { ScenarioReadState } from './ScenarioReadState';
export function ScenarioEntryList({
  entries,
  title,
}: {
  readonly entries: readonly ScenarioEntry[];
  readonly title: string;
}) {
  const [query, setQuery] = useState('');
  const [category, setCategory] = useState('');
  const [selected, setSelected] = useState<ScenarioEntry | null>(null);
  const opener = useRef<HTMLButtonElement | null>(null);
  const visible = selectEntries(entries, query, category);
  function close() {
    setSelected(null);
    opener.current?.focus();
  }
  return (
    <section className="scc-entry-list" aria-label={title}>
      <h2>{title}</h2>
      <div className="scc-filters">
        <label>
          搜索名称、代码或源文字
          <input value={query} onChange={(e) => setQuery(e.target.value)} type="search" />
        </label>
        <label>
          源类别
          <select value={category} onChange={(e) => setCategory(e.target.value)}>
            <option value="">全部源类别</option>
            {sourceCategories(entries).map((value) => (
              <option key={value} value={value}>
                {value}
              </option>
            ))}
          </select>
        </label>
      </div>
      <p role="status">
        {visible.length} / {entries.length} 模板条目 · 保留源顺序
      </p>
      {visible.length === 0 ? (
        <ScenarioReadState
          status="EMPTY_FILTER_RESULT"
          message="本地筛选没有匹配条目；源 Unknown 与数据状态未改变。"
        />
      ) : (
        <ul className="scc-cards">
          {visible.map((entry) => (
            <li key={entry.code}>
              <button
                className="scc-entry-button"
                data-entry-code={entry.code}
                onClick={(e) => {
                  opener.current = e.currentTarget;
                  setSelected(entry);
                }}
              >
                <span className="scc-code">{entry.code}</span>
                <strong>{entry.name}</strong>
                <span>{entry.category}</span>
                {entry.source.suggestionStatus && (
                  <span>
                    {String(entry.source.disposition)} · {String(entry.source.suggestionStatus)}
                  </span>
                )}
                <span>{entry.unknowns.length ? '包含显式 Unknown' : '查看源声明与关联'}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
      {selected && <ScenarioEntryInspector entry={selected} onClose={close} />}
    </section>
  );
}
